import React from 'react';
import AppBarContext from '../../contexts/AppBarContext';
import useLoadContext from '../../hooks/useLoadContext';
import ChangePasswordPanel from './ChangePasswordPanel';

export default function ChangePassword(props) {
  useLoadContext(AppBarContext, { title: 'Change Password' });

  return <ChangePasswordPanel user={props.selectedUser} toast={props.toast} requireCurrent />;
}
